import {
    BackButton,
    LeftContentWrapper,
    RightContentWrapper,
    StyledEyebrow,
    StyledH1,
} from '@/src/modules/pg-plus/PGPlusStyledComponents'
import {
    GIFT_DETAILS_STEP,
    REDEMPTION_SELECT_STEP,
} from '@/src/modules/pg-plus/redemption/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { BrandSearch } from '@/src/modules/algolia/BrandSearch'
import { styled } from '@/src/stitches.config'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import { DISPATCH_SET_STEP } from '@/src/common/reducers/constants'
import Card from '@/src/common/components/marketing/cards/Card'
import { FAQ_PAGE } from '../constants'

const Wrapper = styled('div', {
    maxWidth: '100vw',
    minHeight: '100%',
    display: 'flex',
    fd: 'column',
    '@media (min-width: 765px)': {
        fd: 'row',
        jc: 'space-between',
    },
})

const StyledLeftContentWrapper = styled(LeftContentWrapper, {
    '& p': {
        width: 500,
        maxWidth: '100%',
        lineHeight: '1.5rem',
    },
})

const StyledRightContentWrapper = styled(RightContentWrapper, {
    pt: 30,
    pb: 40,
    px: '5%',
    '.error': {
        marginTop: 0,
        width: 520,
        maxWidth: '90%',
    },
})

type TChangeBrand = {
    error: any[] | null
    exchangeIsError: boolean
    hasBeenCardLinked: boolean
    brandImage: string
}

const PGPlusRedemptionChangeBrandContent = ({
    hasBeenCardLinked,
    error,
    exchangeIsError,
    brandImage,
}: TChangeBrand) => {
    const {
        dispatch,
        giftState,
        numberOfSteps,
        currentStepNumber,
        isUnbrandedToEgift,
    } = usePGPlusStepAndModalContext()
    const { isPgPlus, denomination } = giftState
    const denomInDollars: string = (denomination / 100).toFixed(2)

    return (
        <Wrapper>
            <StyledLeftContentWrapper>
                <BackButton
                    onClick={() => {
                        dispatch({
                            type: DISPATCH_SET_STEP,
                            payload: {
                                stepName: hasBeenCardLinked
                                    ? GIFT_DETAILS_STEP
                                    : REDEMPTION_SELECT_STEP,
                            },
                        })
                    }}
                    data-testid={'back-button'}
                >
                    <FontAwesomeIcon
                        icon={faArrowLeft}
                        style={{ marginRight: '0.5rem' }}
                    />
                    &nbsp;Back
                </BackButton>
                {!hasBeenCardLinked && (
                    <StyledEyebrow
                        label={`Step ${currentStepNumber} of ${numberOfSteps}`}
                        marginTop={'30-on-all-screens'}
                    />
                )}
                <StyledH1 data-testid={'select-h1'}>
                    Choose a <span className={'gradient'}>brand</span>
                </StyledH1>
                <p>
                    We are partnered with a perfect selection of all your
                    favorite national brands in the United States.
                </p>
                {isPgPlus && (
                    <Card
                        size={'lg-with-xs-mobile'}
                        image={brandImage}
                        overlayType={'pg-plus'}
                        isExtended={false}
                        showCustomFields={false}
                        value={`$${denomInDollars}`}
                    />
                )}
            </StyledLeftContentWrapper>
            <StyledRightContentWrapper>
                <BrandSearch
                    denomination={denomination}
                    minHeight={'brands-page'}
                    dispatch={dispatch}
                    isUnbrandedToEgift={isUnbrandedToEgift}
                />
                {error ? (
                    <p className={'error'}>{error}</p>
                ) : (
                    exchangeIsError && (
                        <p className={'error'}>
                            Unable to change brand. Please try again. If issues
                            persist, see our list of{' '}
                            <a href={FAQ_PAGE}>frequently asked questions</a>.
                        </p>
                    )
                )}
            </StyledRightContentWrapper>
        </Wrapper>
    )
}

export default PGPlusRedemptionChangeBrandContent
